import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import Typography from "../LandingComponents/Typography"
import ProjectsGrid from "./ProjectsGrid"

const styles = (theme) => ({
  header: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(6),
  },
  root: {
    marginTop: theme.spacing(17),
    marginBottom: theme.spacing(15),
  },
})

function LandingProjects(props) {
  const { classes, projects, showAll, allProjPics } = props

  return (
    <Container className={classes.root} component="section">
      <Typography
        className={classes.header}
        variant="h4"
        marked="center"
        align="center"
        component="h2"
      >
        {showAll ? "All" : "Current"} Projects
      </Typography>
      <ProjectsGrid
        projectList={projects}
        showAll={showAll}
        allProjPics={allProjPics}
      />
    </Container>
  )
}

LandingProjects.propTypes = {
  allProjPics: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  projects: PropTypes.array.isRequired,
  showAll: PropTypes.bool.isRequired,
}

export default withStyles(styles)(LandingProjects)
